export const locale = {
  lang: 'pt',
  data: {
    SHORTCUT: {
      CLICK_TO_ADD: 'Clique para adicionar / remover um atalho',
      SEARCH_FOR_A_PAGE: 'Pesquisar uma página',
      NO_SHORTCUTS_YET: 'Ainda não há atalhos!',
    },
  },
};
